import { render, staticRenderFns } from "./test-rename.vue?vue&type=template&id=3fe7a1de&scoped=true"
import script from "./test-rename.vue?vue&type=script&lang=js"
export * from "./test-rename.vue?vue&type=script&lang=js"
import style0 from "./test-rename.vue?vue&type=style&index=0&id=3fe7a1de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe7a1de",
  null
  
)

export default component.exports